export const FEAT_GROUP_FORMS: any[] = [
{
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "description", "application" ]
    } ],
    "columns" : [ {
        "name" : "productFeatureGroupId",
        "title" : "Product Feature Group ID"
    }, {
        "name" : "description",
        "title" : "Description"
    }, {
        "name" : "application",
        "title" : "Application"
    } ],
    "formName" : "EditProductFeatureGroups",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
    "type" : "list",
    "fields" : [ {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productFeatureGroupId",
        "description" : "",
        "style" : "",
        "id" : "EditProductFeatureGroups_productFeatureGroupId",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "description",
        "description" : "",
        "style" : "",
        "id" : "EditProductFeatureGroups_description",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "Feature Group Applications",
        "title" : "Application",
        "type" : "HYPERLINK",
        "target" : "UpdateProductFeatureGroup",
        "name" : "application",
        "width" : "",
        "parameterList" : [ {
        "fromField" : {
            "isEmpty" : false,
            "original" : "productFeatureGroupId",
            "bracketedOriginal" : "${productFeatureGroupId}",
            "isAscending" : true,
            "empty" : false,
            "originalName" : "productFeatureGroupId"
        },
        "name" : "productFeatureGroupId"
        } ],
        "style" : "",
        "id" : "EditProductFeatureGroups_application",
        "imageTitle" : "",
        "parameterMap" : { },
        "height" : "",
        "formData":{
            "formName":"EditProductFeatureGroups",
            "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        },
        "event":"edit"
    } ],
    "target" : ""

  },
  {
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "productFeatureGroupId", "productFeatureGroupId", "productFeatureGroupId", "description", "submitButton" ]
    } ],
    "formName" : "EditProductFeatureGroup",
    "altTarget" : [ {
        "useWhen" : "productFeatureGroup==null",
        "targetExdr" : {
        "chars" : "createProductFeatureGroup",
        "hint" : 20,
        "empty" : false,
        "original" : "createProductFeatureGroup"
        }
    } ],
    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
    "type" : "single",
    "fields" : [ {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "250",
        "tabindex" : "",
        "className" : "",
        "title" : "Description",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditProductFeatureGroup_description",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
    }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "EditProductFeatureGroup",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "smallSubmit",
        "id" : "EditProductFeatureGroup_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Update",
        "event" : "",
        "imgSrc" : ""
    } ],
    "target" : "updateProductFeatureGroup"
  },
  {
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "fromDate", "productFeatureId", "description", "productFeatureTypeId", "productFeatureCategoryId", "sequenceNum", "removeFeatureGroupAppl" ]
    } ],
    "columns" : [ {
        "name" : "productFeatureId",
        "title" : "ID"
    }, {
        "name" : "description",
        "title" : "Feature"
    }, {
        "name" : "productFeatureTypeId",
        "title" : "Type"
    }, {
        "name" : "productFeatureCategoryId",
        "title" : "Feature Category"
    }, {
        "name" : "sequenceNum",
        "title" : "Sequence Num"
    }, {
        "name" : "removeFeatureGroupAppl",
        "title" : "Remove"
    } ],
    "formName" : "ListFeatureGroupAppls",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
    "type" : "multi",
    "fields" : [ {
        "conditionGroup" : "",
        "name" : "productFeatureGroupId",
        "action" : "",
        "id" : "ListFeatureGroupAppls_productFeatureGroupId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "conditionGroup" : "",
        "name" : "fromDate",
        "action" : "",
        "id" : "ListFeatureGroupAppls_fromDate",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productFeatureId",
        "description" : "",
        "style" : "",
        "id" : "ListFeatureGroupAppls_productFeatureId",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "description",
        "description" : "",
        "style" : "",
        "id" : "ListFeatureGroupAppls_description",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productFeatureTypeId",
        "description" : "",
        "style" : "",
        "id" : "ListFeatureGroupAppls_productFeatureTypeId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productFeatureCategoryId",
        "description" : "",
        "style" : "",
        "id" : "ListFeatureGroupAppls_productFeatureCategoryId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
    }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "3",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Sequence Num",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "sequenceNum",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "ListFeatureGroupAppls_sequenceNum",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
    }, {
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "Remove",
        "title" : "Remove",
        "type" : "HYPERLINK",
        "target" : "RemoveProductFeatureGroupAppl",
        "name" : "removeFeatureGroupAppl",
        "width" : "",
        "parameterList" : [ {
        "name" : "productFeatureGroupId"
        }, {
        "name" : "productFeatureId"
        }, {
        "name" : "fromDate"
        } ],
        "style" : "",
        "id" : "ListFeatureGroupAppls_removeFeatureGroupAppl",
        "imageTitle" : "",
        "parameterMap" : { },
        "height" : ""
    } ],
    "target" : "UpdateProductFeatureGroupAppl?productFeatureGroupId=${productFeatureGroupId}"
  },
  {
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "productFeatureId", "submitButton" ]
    } ],
    "formName" : "QuickApplyFeatureToGroup",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
    "type" : "single",
    "fields" : [ {
        "conditionGroup" : "",
        "name" : "productFeatureGroupId",
        "action" : "",
        "id" : "QuickApplyFeatureToGroup_productFeatureGroupId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Feature ID",
        "type" : "TEXT",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "productFeatureId",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "QuickApplyFeatureToGroup_productFeatureId",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
    }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "QuickApplyFeatureToGroup",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "smallSubmit",
        "id" : "QuickApplyFeatureToGroup_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Create",
        "event" : "",
        "imgSrc" : ""
    } ],
    "target" : "CreateProductFeatureGroupAppl"
  },
  {
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "productFeatureCategoryId", "submitButton" ]
    } ],
    "formName" : "ApplyFeatureCategoryToGroup",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
    "type" : "single",
    "fields" : [ {
        "conditionGroup" : "",
        "name" : "productFeatureGroupId",
        "action" : "",
        "id" : "ApplyFeatureCategoryToGroup_productFeatureGroupId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Product Feature Category ID",
        "type" : "DROP_DOWN",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "ApplyFeatureCategoryToGroup",
        "options" : [ ],
        "disabled" : "false",
        "id" : "ApplyFeatureCategoryToGroup_productFeatureCategoryId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "productFeatureCategoryId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
    }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "ApplyFeatureCategoryToGroup",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "smallSubmit",
        "id" : "ApplyFeatureCategoryToGroup_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Continue",
        "event" : "",
        "imgSrc" : ""
    } ],
    "target" : "EditFeatureGroupAppls"
  },
  {
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "productFeatureId", "productFeatureTypeId", "description", "idCode", "abbrev", "_rowSubmit" ]
    } ],
    "columns" : [ {
        "name" : "productFeatureId",
        "title" : "ID"
    }, {
        "name" : "productFeatureTypeId",
        "title" : "Type"
    }, {
        "name" : "description",
        "title" : "Feature"
    }, {
        "name" : "idCode",
        "title" : "ID Code"
    }, {
        "name" : "abbrev",
        "title" : "Abbrev"
    }, {
        "name" : "_rowSubmit",
        "title" : "Select"
    } ],
    "formName" : "ApplyFeaturesFromCategoryToGroup",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
    "type" : "multi",
    "fields" : [ {
        "conditionGroup" : "",
        "name" : "productFeatureGroupId",
        "action" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup_productFeatureGroupId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productFeatureId",
        "description" : "",
        "style" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup_productFeatureId",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productFeatureTypeId",
        "description" : "",
        "style" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup_productFeatureTypeId",
        "title" : "",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "description",
        "description" : "",
        "style" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup_description",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "idCode",
        "description" : "",
        "style" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup_idCode",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "abbrev",
        "description" : "",
        "style" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup_abbrev",
        "title" : "",
        "type" : "DISPLAY",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "showSelectAll" : "Y",
        "name" : "_rowSubmit",
        "style" : "",
        "id" : "ApplyFeaturesFromCategoryToGroup__rowSubmit",
        "title" : "Select",
        "type" : "CHECK"
    } ],
    "target" : "ApplyFeaturesFromCategoryToGroup?productFeatureGroupId=${productFeatureGroupId}"
  }
]